// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__5LhXG","title":"style__title__hb6-z","description":"style__description__SjD0F","component":"style__component__tTKvZ"};